import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 w-full bg-white transition-shadow duration-300 ${scrolled ? 'shadow-[0_4px_20px_-8px_rgba(12,10,26,0.12)]' : ''}`}>
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10 h-[78px] flex items-center justify-between">
        <a href="#" className="flex items-center gap-1 lg:-ml-16 xl:-ml-24">
          <img src="/spiick_imgs/logo-green.png" alt="Spiick" className="h-12 md:h-[58px] w-auto" />
        </a>

        <div className="flex items-center gap-5 md:gap-7">
          <a href="#pricing" className="hidden md:inline text-[15px] font-medium text-[#0c0a1a] hover:text-[#F24540] transition-colors">Pricing plans</a>
          <a href="#login" className="hidden md:inline text-[15px] font-medium text-[#0c0a1a] hover:text-[#F24540] transition-colors">Log in</a>
          <a href="#waitlist" data-testid="header-waitlist-cta" className="inline-flex items-center justify-center h-11 px-5 rounded-full bg-[#F24540] text-white text-[14px] font-bold hover:bg-[#d93a35] transition-colors">
            Join the waitlist
          </a>
          <button onClick={() => setOpen(!open)} className="md:hidden p-2 rounded-md hover:bg-black/5">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-white">
          <nav className="flex flex-col px-6 py-4 gap-4 text-[15px] font-medium">
            <a href="#pricing">Pricing plans</a>
            <a href="#login">Log in</a>
          </nav>
        </div>
      )}
    </header>
  );
}
